import { useEffect, useMemo, useState } from 'react';
import AuthPage from './AuthPage';

type AuthMode = 'login' | 'signup';

function resolveMode(pathname: string): AuthMode {
  if (pathname.startsWith('/signup')) return 'signup';
  return 'login';
}

export default function App() {
  const [pathname, setPathname] = useState(() => window.location.pathname);

  useEffect(() => {
    const onPopState = () => setPathname(window.location.pathname);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const mode = useMemo(() => resolveMode(pathname), [pathname]);

  const switchMode = (next: AuthMode) => {
    const target = next === 'signup' ? '/signup' : '/login';
    if (window.location.pathname === target) return;
    window.history.pushState({}, '', `${target}${window.location.search}`);
    setPathname(target);
  };

  return <AuthPage mode={mode} onSwitchMode={switchMode} />;
}
